import {Component, OnInit} from '@angular/core';
import {AppointmentService} from "../../services/appointment.service";
import {AppointmentModel} from "../../../core/models/appointment.model";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {environment} from '../../../../environments/environment';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {FormsModule} from '@angular/forms';
import {MatInput} from '@angular/material/input';
import {MatIcon} from '@angular/material/icon';
import {PreventDoubleClickDirective} from '../../../shared/directives/prevent-doublic-click-directive';
import {MatAnchor, MatButton} from '@angular/material/button';
import {AsyncPipe, DatePipe, NgIf, NgOptimizedImage} from '@angular/common';
import {MatCard, MatCardActions, MatCardContent} from '@angular/material/card';
import {HeadlineTextComponent} from "../../../shared/components/headline-text/headline-text.component";
import {AppointmentDetailsComponent} from "../../components/appointment-details/appointment-details.component";
import {UrlTreeHelper} from "../../../core/services/url-tree-helper";
import {EmbedModeService} from "../../services/embed-mode.service";
import {TestRunService} from "../../services/test-run.service";
import {GtmEventDirective} from "../../../shared/directives/gtm-event.directive";
import {SettingsModel} from "../../../core/models/settings.model";

@Component({
  selector: 'appointment-proposal',
  templateUrl: './proposal.component.html',
  styleUrls: ['./proposal.component.scss'],
  standalone: true,
  imports: [MatCard, NgIf, MatButton, PreventDoubleClickDirective, MatAnchor, MatIcon, MatInput, FormsModule, MatProgressSpinner, AsyncPipe, DatePipe, TranslateModule, MatCardActions, MatCardContent, NgOptimizedImage, HeadlineTextComponent, AppointmentDetailsComponent, GtmEventDirective]
})

export class ProposalComponent implements OnInit {

  readonly API_URL = environment.apiUrl;

  public appointment!: AppointmentModel;
  public settings!: SettingsModel;
  private isTestRun!: boolean;
  private window!: Window;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private appointmentService: AppointmentService,
    private urlTreeHelper: UrlTreeHelper,
    private embedModeService: EmbedModeService,
    private testRunService: TestRunService) {
    this.appointment = this.route.snapshot.data['appointment'];
    this.settings = this.route.snapshot.data['settings'];
    this.isTestRun = this.testRunService.isTestRun();
  }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      if (this.appointment) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'appointment_base_information',
          'planUnit': this.appointment.factoryId,
          'customerType': this.appointment.businessPartnerIsEndUser ? "ENDCUSTOMER" : "CUSTOMER",
          'country': this.appointment.country,
          'language': this.appointment.language,
          'status': this.appointment.status,
        });
      }
    });
  }

  getDeclineKeyForType(type: string): string {
    return `APPOI.PROPOSAL.BUTTON_DECLINE_${type || 'DEFAULT'}`;
  }

  confirm(accept: boolean) {
    const BASE_PATH = '/' + this.route.snapshot.params['factoryId'] + '/' + this.route.snapshot.params['language'] + '/' + this.route.snapshot.params['id'];
    this.appointmentService
      .confirmProposal(this.route.snapshot.params['id'], accept, this.isTestRun)
      .subscribe({
        next: (data) => {
          this.embedModeService.reloadDataEvent();
          if (accept) {
            this.router.navigateByUrl(this.urlTreeHelper.generateUrlTree(
              BASE_PATH, {suffix: 'proposal/accepted'}));
          } else if (this.appointment.flowType === 'PROPOSAL_WITH_ALTERNATIVE_DATES') {
            this.router.navigateByUrl(this.urlTreeHelper.generateUrlTree(
              BASE_PATH, {suffix: 'proposal/declined-timeslot-lookup'}));
          } else {
            this.router.navigateByUrl(this.urlTreeHelper.generateUrlTree(
              BASE_PATH, {suffix: 'proposal/declined-no-timeslot-lookup'}));
          }
        },
        error: error => {
          if (error.error.errorCode === "ENTITY_ALREADY_PROCESSED") {
            this.router.navigateByUrl(this.urlTreeHelper.generateUrlTree(
              BASE_PATH, {prefix: '/processed'}));
          } else {
            this.router.navigateByUrl(this.urlTreeHelper.generateUrlTree(
              BASE_PATH, {prefix: '/not-found'}));
          }
        }
      });
  }
}
